type DateLike = Date | string | { toDate: () => Date } | null | undefined;

/** A stored date of birth (Date, Firestore Timestamp or ISO string) as a Date, or null. */
export function toBirthDate(value: DateLike): Date | null {
  if (!value) return null;
  const date = typeof value === 'object' && 'toDate' in value ? value.toDate()
    : typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00`)
    : new Date(value as Date | string);
  return isNaN(date.getTime()) ? null : date;
}

/** Age in full years on `now`; null when the date is missing, invalid or in the future. */
export function ageFromDateOfBirth(value: DateLike, now: Date = new Date()): number | null {
  const birth = toBirthDate(value);
  if (!birth || birth > now) return null;
  let age = now.getFullYear() - birth.getFullYear();
  const beforeBirthday = now.getMonth() < birth.getMonth()
    || (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate());
  if (beforeBirthday) age -= 1;
  return age;
}
